import { Button } from '@creditornot/cb-button';
import { cbSemanticCssVars, typographyCss } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

type Props = {
  onOpenSftpIntegrationModal: (open: boolean) => void;
};

const IntroContainer = styled.div`
  min-height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 64px 16px;
`;

const IntroHeading = styled.div`
  color: ${cbSemanticCssVars.textSecondary};
  ${typographyCss.Body2}
  font-weight: bold;
`;

const IntroDetails = styled.div`
  color: ${cbSemanticCssVars.textSecondary};
  margin-block-end: 30px;
  ${typographyCss.Body3}
`;

const SftpIntegrationIntroduction = ({ onOpenSftpIntegrationModal }: Props) => {
  return (
    <IntroContainer>
      <IntroHeading>
        <FormattedMessage id="merchant-integrations.sftp.intro.heading" />
      </IntroHeading>
      <IntroDetails>
        <FormattedMessage id="merchant-integrations.sftp.intro.details" />
      </IntroDetails>

      <Button size="small" variant="blue" onClick={() => onOpenSftpIntegrationModal(true)}>
        <FormattedMessage id="merchant-integrations.sftp.intro.integrate" />
      </Button>
    </IntroContainer>
  );
};

export default SftpIntegrationIntroduction;
